__turbopack_context__.v({
  "breadcrumbsWrapper": "_1S0Caa_breadcrumbsWrapper",
});
